/**
 * Feature flag hook and utilities.
 *
 * Uses regionConfig.features to determine which features are available.
 * Usage:
 *   const hasPix = useFeatureFlag('pix');
 *   if (isFeatureEnabled('tunaPayments')) { ... }
 */
import regionConfig from '../config/regionConfig';

/**
 * React hook to check if a feature is enabled.
 * @param {string} feature - Feature key from regionConfig.features
 * @returns {boolean}
 */
export function useFeatureFlag(feature) {
  return regionConfig.features[feature] ?? false;
}

/**
 * Non-hook function to check if a feature is enabled.
 * Can be used outside of React components.
 * @param {string} feature - Feature key from regionConfig.features
 * @returns {boolean}
 */
export function isFeatureEnabled(feature) {
  return regionConfig.features[feature] ?? false;
}

/**
 * Get the current region identifier.
 * @returns {string} 'br' or 'lb'
 */
export function getRegion() {
  return regionConfig.region;
}

export default useFeatureFlag;
